import { render } from "./currency-switch.vue?vue&type=template&id=1bd00aba&scoped=true"
import script from "./currency-switch.vue?vue&type=script&lang=js"
export * from "./currency-switch.vue?vue&type=script&lang=js"

import "./currency-switch.vue?vue&type=style&index=0&id=1bd00aba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd00aba"]])

export default __exports__